module.exports = __webpack_public_path__ + "img/main_partner_reference_hover.96b43517.png";